(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.investment-restricted-investor-blocked-dialog', [
    'pp.widgets-templates',
    'pp.services.dialog',
    'pp.services.route',
    'pp.ui.services.classification-dialog'
]);

ngModule.component('ppInvestmentRestrictedInvestorBlockedDialog', {
    templateUrl: 'widgets/_angular/invesment-restricted-investor-blocked-dialog/invesment-restricted-investor-blocked-dialog.tpl.html',
    bindings: {
        user: '<'
    },
    controllerAs: 'vm',
    controller: ['$scope', 'routeService', 'classificationDialogService', 'dialogService', function ($scope, routeService, classificationDialogService, dialogService) {
        var vm = this;

        // -- initial state

        vm.learnMoreLink = routeService.retailInvestorBlockedInvestment;
        vm.marketplacePath = routeService.marketplacePath;
        vm.contactUsPath = routeService.contactUsPath;

        // -- util functions

        // -- api
        vm.closeModal = function () {
            dialogService.close();
        };

        vm.reclassify = function () {
            dialogService.resolve(classificationDialogService.reclassifyUser.bind(null, vm.user));
        };

        // -- scope bindings

        // -- main

    }]
});
})(window, window.angular);